import type { PageType } from '../analytics'
import type { CountryConfiguration } from '../countryConfiguration'

export const enum Brand {
	She = 'she',
	He = 'he',
	Teen = 'teen',
	Kids = 'kids',
	Home = 'home',
	Girl = 'girl',
	Boy = 'boy',
}

export const enum Device {
	Mobile = 'mobile',
	Desktop = 'desktop',
}

export const enum Channel {
	Shop = 'shop',
	Outlet = 'outlet',
	Backoffice = 'backoffice',
}

export const enum Environment {
	Pro = 'pro',
	Pre = 'pre',
	Dev = 'dev',
	Local = 'local',
}

export type HeaderValue = string | null | undefined

export interface MasterData {
	brand: Brand | null
	h1LogoKey: string | undefined
	pageType: PageType
	device: Device
	isApp: boolean
	customDate: Date | null
	channel: Channel
	isShop: boolean
	isMobile: boolean
	isDesktop: boolean
	isBot: boolean
	isCicd: boolean
	isQa: boolean
	referer: HeaderValue
	dev: HeaderValue
	url: HeaderValue
	region: HeaderValue
	country: CountryConfiguration
	environment: Environment
	/** @deprecated only for error monitoring */
	userAgent?: HeaderValue
	isReady?: boolean
}
